<template>
  <base-dialog :show-dialog="dialog">
    <template v-slot:body>
      <v-card class="pt-4 pb-2">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                placeholder="Informe a condição de pagamento"
                label="Condição de Pagamento"
                class="text caption ml-1"
                v-model="value"
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-data-table
              dense
              dark
              :headers="selectedHeaderOptions"
              :items="cmpPaymentConditionsList"
              :loading="loadingItems"
              :items-per-page="10"
              :search="value"
              :item-class="estiloLinha"
            >
              <template v-slot:item.pin="{ item }">
                <v-btn-toggle tile>
                  <v-btn fab color="warning" x-small @click="pinObject(item)">
                    <v-icon color="white">mdi-pin-outline</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="closeForm()">
            <span class="white--text">
              Fechar
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog.vue'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { parcelMixin } from '@/mixins/object/parcels/ParcelMixin'

import { mapState, mapActions } from 'vuex'
export default {
  components: {
    BaseDialog,
  },
  mixins: [tableMixin, parcelMixin],
  data: () => {
    return {
      timer: null,
      value: '',
      item: undefined,
      dialog: false,
    }
  },
  computed: {
    ...mapState('paymentConditionsModule', [
      'pagination',
      'loadingItems',
      'paymentConditionsList',
    ]),
    cmpPaymentConditionsList() {
      // caso um dia necessite mostrar todas as condicoes, basta remover o .filter()
      const list = this.paymentConditionsList
        .map((element) => ({
          ...element,
          selected: this.item && element.CODIGO == this.item.CODIGO,
        }))
        .filter((element) => element.selected == true)
      return list
    },
    selectedHeaderOptions() {
      return [
        { text: 'Código', value: 'CODIGO' },
        { text: 'Nome', value: 'NOME', width: '280px' },
        {
          text: 'Ações',
          value: 'pin',
          align: 'right',
        },
      ]
    },
  },
  methods: {
    pinObject(item) {
      this.$emit('object-pin', item)
      this.value = undefined
      this.agree()
    },
    estiloLinha(value) {
      return value.selected ? 'active' : undefined
    },
    ...mapActions('paymentConditionsModule', [
      'getPaymentConditionsAPI',
      'getPaymentConditionAPI',
    ]),

    async getDados(object) {
      try {
        await this.getPaymentConditionsAPI(object)

        // parcel mixin
        const condicaoDefaultFlag = this.getCondicaoPgtoDefault()

        if (condicaoDefaultFlag) this.value = condicaoDefaultFlag
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    closeForm() {
      /*
       * Vai levar seguir o fluxo do gestao
       * Caso tenha uma condicao de pagamento vinda da empresa(passado como parametro por open(paymentCondition))
       * ira exibir apenas a da empresa e ao fechar sem o usuário clicar no pin, forcara retorno desta condicao
       */
      this.$emit('object-pin', this.item)
      if (!this.item) this.cancel()
      else this.agree()
    },
    open(paymentCondition = null) {
      this.dialog = true
      this.item = paymentCondition
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
  async mounted() {
    await this.getDados({ todos: 'S' })
  },
}
</script>

<style></style>
